var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatAddOnFill0Wght400Grad0Opsz48(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 96 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 896V276q0-24.75 17.625-42.375T180 216h520q24.75 0 42.375 17.625T760 276v223q-10-2-20-2.5t-20-.5q-5 0-10 .167-5 .166-10 .833V276H180v440h301q-.667 5-.833 10-.167 5-.167 10 0 10 .5 20t2.5 20H240L120 896Zm160-460h320v-60H280v60Zm0 170h200v-60H280v60Zm410 280V766H570v-60h120V586h60v120h120v60H750v120h-60ZM180 716V276v440Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatAddOnFill0Wght400Grad0Opsz48);
export default __webpack_public_path__ + "static/media/chat_add_on_FILL0_wght400_GRAD0_opsz48.f483ad8dee7e80eca8cad3aefa199c70.svg";
export { ForwardRef as ReactComponent };